import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ImportCompanyDTO, ImportOrderDTO, ImportProjectDTO, ImportUserDTO } from '../_models/projects';

@Injectable({
  providedIn: 'root'
})
export class ImportService {

  constructor(private http : HttpClient) { }

  getProjects(selectedLocation:string): Observable<ImportProjectDTO[]> {
    const params =  new HttpParams().set('location', selectedLocation ?? '');
    return this.http.get<ImportProjectDTO[]>(environment.apiUrl + `/projects/importprojects`,{params});
  }

  getLocations(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + `/datasource/locations`);
  }

  importProjects(requestData:any): Observable<ImportProjectDTO[]> {
    return this.http.post<ImportProjectDTO[]>(environment.apiUrl + `/projects/add/importedprojects`,requestData);
  }

   getCompanies(selectedLocation:string,projectId:number): Observable<ImportCompanyDTO[]> {
    const params =  new HttpParams().set('location', selectedLocation ?? '')
    .set('projectId', projectId.toString());
    return this.http.get<ImportCompanyDTO[]>(environment.apiUrl + `/import/companies`,{params});
  }

  getOrders(selectedLocation:string,idocsProjectId:number,projectId:number): Observable<ImportOrderDTO[]> {
    const params =  new HttpParams().set('location', selectedLocation ?? '')
    .set('idocsProjectId', idocsProjectId.toString())
    .set('projectId', projectId.toString());
    return this.http.get<ImportOrderDTO[]>(environment.apiUrl + `/import/orders`,{params});
  }

  getUsers(selectedLocation:string,idocsProjectId:number): Observable<ImportUserDTO[]> {
    const params =  new HttpParams().set('location', selectedLocation ?? '')
    .set('idocsProjectId', idocsProjectId.toString());
    return this.http.get<ImportUserDTO[]>(environment.apiUrl + `/import/users`,{params});
  }

  addSelectedCompaniesToDb(listOfCompanies:ImportCompanyDTO[], selectedProjectId:number): Observable<ImportCompanyDTO[]> {
    return this.http.post<ImportCompanyDTO[]>(environment.apiUrl + `/imported/companies/add/${selectedProjectId}`,listOfCompanies);
  }

  addSelectedOrdersToDb(listOfOrders:ImportOrderDTO[], selectedProjectId:number): Observable<ImportOrderDTO[]> {
    return this.http.post<ImportOrderDTO[]>(environment.apiUrl + `/imported/orders/add/${selectedProjectId}`,listOfOrders);
  }

  addSelectedUsersToDb(listOfUsers:ImportUserDTO[], selectedProjectId:number): Observable<ImportUserDTO[]> {
    return this.http.post<ImportUserDTO[]>(environment.apiUrl + `/imported/users/add/${selectedProjectId}`,listOfUsers);
  }
}
